/** Generische JuicyFinance-Filter — flach wie andere Typ-Filter (keine Token-Varianten). */

/** B3TR / VET / VTHO Tax-Tabellen — nur Klassen, die dort tatsächlich landen */
export const JUICY_TAX_TYPE_FILTER_OPTIONS = [
  { value: "juicyfinance_lending_income", label: "🟦 JuicyFinance Lending Income" },
  { value: "juicyfinance_b3tr_reward_claim", label: "🟦 JuicyFinance B3TR Incentive Reward" },
  { value: "juicyfinance_liquidation_collateral_received", label: "🟦 JuicyFinance Liquidation Collateral In" },
  { value: "juicyfinance_liquidation_debt_payment", label: "🟦 JuicyFinance Liquidation Debt Payment" },
  { value: "juicyfinance_borrow_principal", label: "🟦 JuicyFinance Borrow Principal" },
  { value: "juicyfinance_repay_principal", label: "🟦 JuicyFinance Repay Principal" },
  { value: "juicyfinance_borrow_interest_paid", label: "🟦 JuicyFinance Borrow Interest Paid" },
  {
    value: "juicyfinance_unmatched_withdrawal_principal",
    label: "🟦 JuicyFinance Unmatched Withdrawal",
  },
];

/** Raw Transfers — wenige Filter; Werte matchen asset-übergreifend per Muster */
export const JUICY_RAW_TYPE_FILTER_OPTIONS = [
  { value: "juicyfinance_lending_income", label: "🟦 JuicyFinance Lending Income" },
  { value: "juicy_deposit", label: "🟦 JuicyFinance Deposit" },
  { value: "juicy_withdrawal", label: "🟦 JuicyFinance Withdrawal" },
  { value: "juicy_borrow", label: "🟦 JuicyFinance Borrow" },
  { value: "juicy_repay", label: "🟦 JuicyFinance Repay" },
  { value: "juicyfinance_borrow_principal", label: "🟦 JuicyFinance Borrow Principal" },
  { value: "juicyfinance_repay_principal", label: "🟦 JuicyFinance Repay Principal" },
  { value: "juicyfinance_borrow_interest_paid", label: "🟦 JuicyFinance Borrow Interest Paid" },
  { value: "juicy_receipt_in", label: "🟦 JuicyFinance Position In" },
  { value: "juicy_receipt_out", label: "🟦 JuicyFinance Position Out" },
  { value: "juicy_receipt_internal", label: "🟦 JuicyFinance Internal Position" },
  {
    value: "juicyfinance_unmatched_withdrawal_principal",
    label: "🟦 JuicyFinance Unmatched Withdrawal",
  },
];

export function matchesJuicyRawTypeFilter(classLower, filterValue) {
  const cls = String(classLower || "").toLowerCase();
  const f = String(filterValue || "").toLowerCase();
  if (!cls || !f) return false;

  switch (f) {
    case "juicyfinance_lending_income":
    case "juicyfinance_b3tr_reward_claim":
    case "juicyfinance_borrow_principal":
    case "juicyfinance_repay_principal":
    case "juicyfinance_borrow_interest_paid":
    case "juicyfinance_unmatched_withdrawal_principal":
    case "juicyfinance_lending_dust_adjustment":
    case "juicyfinance_liquidation_collateral_received":
    case "juicyfinance_liquidation_debt_payment":
      return cls === f;
    case "juicy_deposit":
      return /^juicyfinance_[a-z0-9]+_deposit$/.test(cls);
    case "juicy_withdrawal":
      return /^juicyfinance_[a-z0-9]+_withdrawal$/.test(cls);
    case "juicy_borrow":
      return /^juicyfinance_[a-z0-9]+_borrow$/.test(cls);
    case "juicy_repay":
      return /^juicyfinance_[a-z0-9]+_repay$/.test(cls);
    case "juicy_receipt_in":
      return /^juicyfinance_[a-z0-9]+_receipt_transfer_in$/.test(cls);
    case "juicy_receipt_out":
      return /^juicyfinance_[a-z0-9]+_receipt_transfer_out$/.test(cls);
    case "juicy_receipt_internal":
      return /^juicyfinance_[a-z0-9]+_receipt_internal_transfer$/.test(cls);
    case "juicy_liquidation":
      return (
        cls === 'juicyfinance_liquidation_collateral_received' ||
        cls === 'juicyfinance_liquidation_debt_payment'
      );
    default:
      return false;
  }
}
